import { ThemeType } from '../types.js';
const name = 'rangers';
const displayName = 'Rangers';
const type = ThemeType.Club;
const socials = {
    facebookUrl: 'https://www.facebook.com/profile.php?id=61586107954371',
};
// TODO: Move to CMS
const assets = {
    favicon: '/assets/images/rangers/logo.svg',
    logo: '/assets/images/rangers/logo.svg',
    logoLight: '/assets/images/rangers/logo.svg',
    logoMobile: '/assets/images/rangers/logo.svg',
    logoCard: '/assets/images/rangers/logo.svg',
    banner: '/assets/images/rangers/banner.webp',
    logoBanner: '/assets/images/rangers/logo-sm.svg',
    partners: [
        '/assets/images/partners/rangers/umbro.png',
        '/assets/images/partners/rangers/32-red.png',
        '/assets/images/partners/rangers/kelloggs.png',
        '/assets/images/partners/rangers/unibet.png',
        '/assets/images/partners/rangers/seko.png',
    ],
};
const primitives = {
    theme: {
        extend: {
            colors: {
                white: '#F8FAFC',
                'pure-white': '#FFFFFF',
                primary: '#0032A0', // blue
                'primary-light': '#62A8FF', // blue
                'primary-lighter': '#E5EEFF', // lighter blue
                secondary: '#FF0000', // red
                'secondary-dark': '#FF0000', // red
                'secondary-light': '#FF0000', // red
                tertiary: '#FF0000', // red
                'tertiary-light': '#FF0000', // red
                'tertiary-dark': '#FF0000', // red
                black: '#1E293B', // black
                'black-light': '#566989', // light black
                teal: '#FF0000', // red
                'pastel-blue': '#FF0000', // red
            },
        },
    },
};
export default {
    assets,
    displayName,
    name,
    primitives,
    socials,
    type,
};
